<template>
  <div class="page-demo-player">
    <div class="overlay" v-if="!loaded || !cfg">
      <PPSpinner v-if="!message"/>
      <div v-if="message" class="error-message">
        {{message}}
      </div>
    </div>

    <img class="poster" v-if="picture" :src="picture" alt="Poster Image" @click="posterClick()">
    <div class="poster startbtn" v-if="picture" @click="posterClick()">
      <Icon style="fill:white"/>
    </div>

    <div v-if="loaded && asset && !picture">
      <Player :asset="asset" class="player" v-on:player="initPlayer($event.ppPlayer)"/>
    </div>
  </div>

</template>

<script>
import Player from '../components/player/Player';
import PPSpinner from '../../../submodules/prestoplay-web-ui-vue/src/components/PPSpinner.vue';
import Icon from '../../../submodules/prestoplay-web-ui-vue/src/style/assets/play-circle.svg';
import load from '../utils/fetch';
import { convertFromAssetDb } from '../utils/assetdb_utils';
import 'url-search-params-polyfill';

export default {
  name: 'page-embedded-player',
  components: { Player, PPSpinner, Icon },
  data () {
    return {
      player: null,
      cfg: null,
      id: null,
      message: '',
      started: false
    };
  },
  watch: {
    loaded: function (n) {
      if (n && this.id && !this.cfg) {
        this.loadAssetConfig();
      }
    }
  },
  computed: {
    loaded () {
      return this.$store.state.scripts.loaded;
    },
    asset () {
      if (!this.cfg) return null;
      return clpp.utils.PlayerConfiguration.create(this.cfg);
    },
    picture () {
      if (!this.asset || !this.asset.metadata || !this.asset.metadata.posterUrl || this.started) return null;
      if (!this.cfg || this.cfg.autoplay) return null;
      let url = this.asset.metadata.posterUrl;
      if (url) {
        url = url.replace(/^https?:\/\//, '//');
      }
      return url;
    },
  },
  mounted () {
    const uri = window.location.search.substring(1);
    const params = new URLSearchParams(uri);
    if (params.get('cfg')) {
      this.cfg = JSON.parse(atob(params.get('cfg')));
    } else if (params.get('id')) {
      this.id = params.get('id');
      if (this.loaded) {
        this.loadAssetConfig();
      }
    }
  },
  methods: {
    initPlayer (ref) {
      this.player = ref;
    },
    posterClick () {
      this.started = true;
      if (this.started) {
        this.cfg.autoplay = true;
      }
    },
    loadAssetConfig () {
      const assetUrl = `https://assets.castlabs.com/api/config/${this.id}/`;
      load(assetUrl).then(async (response) => {
        return { body: await response.json(), status: response.status };
      }).then((msg) => {
        const cfg = msg.body;
        if (msg.status < 200 || msg.status >= 400) {
          this.message = 'Unable to load configuration!';
          return;
        }
        const c = convertFromAssetDb(cfg);
        if (c) {
          this.cfg = c.cfg;
        } else {
          this.message = 'Unable to load configuration!';
        }
      }).catch((e) => {
        this.message = 'Unable to load configuration: ' + e.message;
        console.log('Ups, something went wrong while loading the asset config', e);
      });
    }
  }
};
</script>

<style lang="scss">
  @import "../style/color_";

  .page-demo-player {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 100%;
    background-color: black;

    .poster {
      position: absolute;
      z-index: 10;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
      cursor: pointer;
    }
    .startbtn {
      min-width: 15rem;
      min-height: 15rem;
    }

    .overlay {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .error-message {
      color: $color-cl-red;
    }
}
.pp-ui-video-container {
  height: 100vh;
  padding: 0;
}

</style>
